import type { ProjectUnit } from "@shared/schema";

/**
 * Resolve a unit's URL slug. Falls back to a slugified version of the
 * label so legacy seeded units (no slug) still link properly.
 */
export function unitSlug(unit: Pick<ProjectUnit, "id" | "label" | "slug">): string {
  if (unit.slug && unit.slug.trim()) return unit.slug;
  return (
    unit.label
      .toLowerCase()
      .replace(/[áàâãä]/g, "a")
      .replace(/[éèêë]/g, "e")
      .replace(/[íìîï]/g, "i")
      .replace(/[óòôõöő]/g, "o")
      .replace(/[úùûüű]/g, "u")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "") || unit.id.slice(0, 8)
  );
}

export const UNIT_STATUS_LABEL: Record<ProjectUnit["status"], string> = {
  available: "Szabad",
  reserved: "Foglalt",
  sold: "Eladott",
};

export const UNIT_STATUS_BADGE: Record<ProjectUnit["status"], string> = {
  available: "bg-emerald-100 text-emerald-700",
  reserved: "bg-amber-100 text-amber-700",
  sold: "bg-brand-100 text-brand-500",
};
